import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateLiquidacioneForm } from '../Validations/ValidationsLiquidacione';

export default function EditLiquidacioneForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '', terceroId: '', tramiteId: '', tramiteTipo: '', fecha: '',
        concepto: '', importe: '', observaciones: '', sepulturaId: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchLiquidacione = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/liquidaciones/${id}`);
                setFormData(response.data);
            } catch {
                setError('Error al cargar los datos * de la liquidación.');
            } finally {
                setIsLoading(false);
            }
        };
        if (id) fetchLiquidacione();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = await validateLiquidacioneForm(formData);
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.put(`/liquidaciones/${id}`, formData);
                navigate('/home/liquidaciones');
            } catch {
                setError('Error al actualizar la liquidación.');
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    if (isLoading) return <div className="text-center mt-8">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-4xl mx-auto mt-8 bg-green-50 p-6 rounded-lg shadow-lg">
            <h2 className="text-3xl font-bold mb-6 text-green-700">Editar Liquidación</h2>
            <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
                <div className="col-span-2">
                    <label className="block mb-1 font-semibold">ID</label>
                    <input type="text" name="id" value={formData.id} readOnly className="w-full p-2 border rounded bg-gray-200" />
                </div>
                {[ 
                    { name: 'terceroId', label: 'Tercero ID' },
                    { name: 'tramiteId', label: 'Trámite ID' },
                    { name: 'tramiteTipo', label: 'Trámite Tipo' },
                    { name: 'fecha', label: 'Fecha', type: 'date' },
                    { name: 'concepto', label: 'Concepto' },
                    { name: 'importe', label: 'Importe', type: 'number' },
                    { name: 'sepulturaId', label: 'Sepultura ID' }
                ].map(({ name, label, type = 'text' }) => (
                    <div key={name}>
                        <label className="block mb-1 font-semibold">{label}</label>
                        <input type={type} name={name} value={formData[name]} onChange={handleChange} 
                            className={`w-full p-2 border rounded ${errors[name] ? 'border-red-500' : ''}`} required />
                        {errors[name] && <p className="text-red-500 text-xs italic">{errors[name]}</p>}
                    </div>
                ))}
                <div className="col-span-2">
                    <label className="block mb-1 font-semibold">Observaciones</label>
                    <textarea name="observaciones" value={formData.observaciones} onChange={handleChange} 
                        className={`w-full p-2 border rounded ${errors.observaciones ? 'border-red-500' : ''}`} required />
                    {errors.observaciones && <p className="text-red-500 text-xs italic">{errors.observaciones}</p>}
                </div>
                <div className="col-span-2">
                    <button type="submit" className="w-full bg-green-600 text-white p-2 rounded hover:bg-green-700">
                        {isLoading ? 'Actualizando...' : 'Actualizar Liquidación'}
                    </button>
                </div>
            </form>
        </div>
    );
}
